import {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import {NMB, PRE, VID} from './../../../constants/identifiers';
import {MATCHDAY} from "../../../constants/identifiers";


const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        events: state.vpp.events,
        selectedEventIndex: state.vpp.selectedEventIndex,
        screenOrientation: state.vpp.screenOrientation,
        betsCommitting: state.vpp.betsCommitting,
        isBetSlipSideView: state.vpp.isBetSlipSideView,
        systemLanguage: state.vpp.systemLanguage
    };
};

class VerticalScrollController extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            betsCommitting: storeData.vpp.betsCommitting,
            isBetSlipSideView: storeData.vpp.isBetSlipSideView,
            events: storeData.vpp.events,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            screenOrientation: storeData.vpp.screenOrientation,
            systemLanguage: storeData.vpp.systemLanguage
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            let storeDataEvents;
            let selectedEvent;

            if (storeData.vpp.events.length !== 0 && storeData.vpp.events[0].eventType === MATCHDAY) {
                selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex][0];
            } else {
                selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
            }

            let currentSelectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex]
            let isSelectedEventAlreadyNmb = this.state.noMoreBetsEventList.find((event) => (selectedEvent && event.eventId === selectedEvent.eventId && event.gameChannel === currentSelectedGame.channel))
            let isSelectedEventNmb = storeData.vpp.noMoreBetsEventList.find((event) => (selectedEvent && event.eventId === selectedEvent.eventId && event.gameChannel === currentSelectedGame.channel))

            if (storeData.vpp.selectedGameIndex !== this.state.selectedGameIndex
                || ((currentSelectedGame.controllerState === PRE || (currentSelectedGame.controllerState !== undefined && currentSelectedGame.controllerState[1] !== undefined && (currentSelectedGame.controllerState[1] === NMB || currentSelectedGame.controllerState[1] === PRE))) && isSelectedEventNmb && !isSelectedEventAlreadyNmb)
                || (storeData.vpp.screenOrientation === "portrait" && this.state.screenOrientation === "landscape" && (currentSelectedGame.controllerState === VID || (currentSelectedGame.controllerState !== undefined && currentSelectedGame.controllerState[1] !== undefined && currentSelectedGame.controllerState[1] === VID)))
                || (!this.state.isBetSlipSideView && this.state.betsCommitting)) {
                document.getElementById("bottomContainer").scrollTo({top: 0, behavior: 'smooth'}) //for desktop view
                document.getElementById('gameIframe').scrollTo({top: 0, behavior: 'smooth'})  //for mobile view
            }

            this.setState({
                ...this.state,
                games: storeData.vpp.games,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                betsCommitting: storeData.vpp.betsCommitting,
                isBetSlipSideView: storeData.vpp.isBetSlipSideView,
                events: storeData.vpp.events,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                screenOrientation: storeData.vpp.screenOrientation,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }

    render() {
        return ''
    }
}

export default connect(mapStateToProps)(VerticalScrollController);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/verticalScrollController.js